import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':toolId'}/changeState`;

export const ROUTE: RouteDefinition = `${baseRoute}/:toolId/changeState`;

export const URL = (toolId: number): RouteDefinition => `${baseRoute}/${toolId}/changeState`;
